// **** import modules ****
import $ from "jquery";
//import { csl } from "@pressmedia/webappbase";

export default {
	init() {
		if( !location.search.includes("category_name") ) {
			return false;
		}
		// URLを取得
		const url = new URL(window.location.href);
		const params = url.searchParams;
		const target = params.get("category_name");
		let pageType = "";
		const self = this;
		
		if( target.includes("value") ||
				target.includes("tourism") ||
				target.includes("news") ) {
	
			pageType = self._existTarget(target);
			const $areaList = $("#area-list").children(".menu-item");
			
			$($areaList).each( function( index, element ) {
				const $searchLink = $(element).children("a");
				const href = $searchLink.attr("href");
				const params = href.split("?");
				const area = href.split("=");
				if(params.length && params[1]) {
					const listParam = self._existTarget(params[1]);

					if(listParam === "") {
						$searchLink.attr("href", href + "+" + pageType );
					}
				}
				
				if( target.indexOf(area[1]) > -1 ) {
					$searchLink.addClass("is-active");
				}
			});
		}
		return this;
	},
	
	_existTarget(param) {
		const taragetList = ["value", "tourism", "news"];
		let resutl = "";
		taragetList.some(element => {
			if(param.includes(element) ) {
				resutl = element;
				return true;
			}
		});
		
		return resutl;
	}
};